module.exports = __webpack_public_path__ + "img/remove-selected.c86d8d34.svg";